import { Model } from ".";

export default class ScheduleWeather extends Model {
	get singularNoun() {
		return "schedule weather";
	}

	resource() {
		return "weather/schedules";
	}
}
